<script>
    /*
    	FiltersMenu.svelte
    */

    import { onMount } from 'svelte';

    // TCARE components
	import FiltersMenuCategory from "./FiltersMenuCategory.svelte";
	import SelectedFilterButton from "./SelectedFilterButton.svelte";
	import ClearFiltersButton from "./ClearFiltersButton.svelte";
    import {asyncValidatePostalCode} from "../../common/utils";
    import {masterSearch} from "../../common/master-objects";
    import {isShowingZipError} from "../../stores/ScreenSettingsStore";
	// import ApplyFiltersButton from "./ApplyFiltersButton.svelte";
    

    $: taxonomy = $searchStore.taxonomies[taxonomyName];        // reactive - assumes valid name passed in
    $: preparedCategories = prepareTaxonomy(taxonomy);          // only categories with filtered children
    $: selectedNodes = taxonomy.getSelectedNodes();

    export let searchStore;                                     // Svelte store masterSearch
    export let taxonomyName;                                    // which taxonomy to use (DEMOGRAPHICS)
    export let onSearch;
    export let isOpen;

    onMount(() => {
        // console.log('ResourceExplorerPage onMount');
        // console.log('preparedCategories');
        // console.log(preparedCategories);
    })

    // order by number of filtered children checkboxes - returns an array
    const prepareTaxonomy = (tax) => {
        // make another array for the taxonomy items so it won't get sorted too!
        const topItems = tax.getTopLevelItems();            // about 22 categories
        const prunedItems = sortByNumberOfFilteredChildren(topItems);
        return prunedItems;
    }

    // make another array for the taxonomy items so it won't get sorted too!
    const sortByNumberOfFilteredChildren = (items) => {
        const MAX_CHILDREN = 100;
        const sortedItems = [];
        const prunedItems = [];

        // add a temp prop to compare
        for (const item of items) {
            item.filteredCount = taxonomy.getFilteredChildrenCount(item);
        }

        // above MAX will not be sorted
        for (const item of items) {
            if (item.filteredCount > MAX_CHILDREN) sortedItems.push(item);
        }

        // loop within a loop!
        for (let i = MAX_CHILDREN; i >= 0; i--) {
            for (const item of items) {
                if (item.filteredCount === i) {
                    sortedItems.push(item);
                }
            }
        }

        // exclude 0 counts
        for (const item of sortedItems) {
            if (item.filteredCount > 0) {
                prunedItems.push(item);
            }
        }

        // remove temp prop
        for (const item of items) {
            delete item.filteredCount;
        }

        return prunedItems;
    }

    // close the "chip" and de-select
    const _onSelFilterButtonClick = (node) => {
        node.isSelected = false;
        onSearch();                     // runResourcePageDemographicsSearch
    }

    // const _onApplyFiltersButtonClick = () => {
    //     onSearch();                     // runResourcePageDemographicsSearch
    // }
    
    const _onClearFiltersButtonClick = async () => {
        if (selectedNodes.length === 0) return;

        const isValidZipCode = await asyncValidatePostalCode($masterSearch.location.postalCode)
        if (!isValidZipCode) {
            $isShowingZipError = true
            return false
        } else {
            $isShowingZipError = false
        }

        taxonomy.selectAllNodes(false);
        $searchStore = $searchStore;
        onSearch();
    }
    

</script>

<style>
    .filters-menu {
        user-select: none;
        width: 100%;
        /* border: 1px solid red; */
    }

    .selected-filters {
        width: 100%;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="filters-menu">
    {#if isOpen}
        <!-- menu is open - show checkboxes -->
        <!-- <ApplyFiltersButton onClick={_onApplyFiltersButtonClick} /> -->
        <ClearFiltersButton onClick={_onClearFiltersButtonClick} />
        {#each preparedCategories as category}
            <FiltersMenuCategory {searchStore} {category} {onSearch} />
        {/each}
    {:else}
        <!-- menu is closed - show selected chip buttons -->
        <div class="selected-filters">
            {#each selectedNodes as node}
                <SelectedFilterButton {node} onClick={() => _onSelFilterButtonClick(node)} />
            {/each}
        </div>
    {/if}
</div>
